import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { serviciosService } from "../../services/api";
import PrecioAnimado from "../Animaciones/PrecioAnimado";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./Servicios.css";

function Servicios({ onReservar }) {
  const [categoriaActiva, setCategoriaActiva] = useState("manos");
  const [preciosAbierto, setPreciosAbierto] = useState(false);
  const [servicios, setServicios] = useState([]);
  const [cargando, setCargando] = useState(true);

  const _categorias = [
    { id: "manos", label: "Uñas · Manos" },
    { id: "pies", label: "Uñas · Pies" },
    { id: "otros", label: "Otros servicios" },
    { id: "pestanas", label: "Pestañas" },
    { id: "mantenimientos", label: "Mantenimientos" },
  ];

  const _notasDestacadas = {
    manos: "Liso / simple: color liso, nude, brillo o detalles sutiles. Diseño Glow: french, aurora, chrome, cat eye o diseños simples. Los diseños elaborados se cotizan según la inspiración.",
    pestanas: "Los diseños especiales (espigas, wispy o colores) tienen un valor extra que se conversa en la cita.",
  };

  const _notas = {
    otros: "El retiro está incluido en mantenimientos mensuales de clientas GlowRoom, siempre que el trabajo anterior haya sido realizado en el salón.",
    mantenimientos: "El mantenimiento aplica siempre que quede una cantidad adecuada de extensiones. Pasadas las 3 semanas, o si queda muy poca cantidad, se toma como colocación nueva. Se realiza una sola vez; luego se realiza retiro y colocación nueva desde cero.",
  };

  useEffect(() => {
    cargarServicios();
  }, []);

  const cargarServicios = async () => {
    setCargando(true);
    try {
      const respuesta = await serviciosService.obtenerTodos();
      setServicios(respuesta.data);
    } catch (error) {
      console.error("Error al cargar servicios", error);
    } finally {
      setCargando(false);
    }
  };

  const _serviciosFiltrados = servicios.filter(s => s.categoria === categoriaActiva);

  const _serviciosAgrupados = _serviciosFiltrados.reduce((acc, s) => {
    const _grupo = acc.find((g) => g.nombre === s.nombre);
    if (_grupo) {
      _grupo.variantes.push(s);
    } else {
      acc.push({ nombre: s.nombre, variantes: [s] });
    }
    return acc;
  }, []);

  const _contenedorFilas = {
    oculto: {},
    visible: { transition: { staggerChildren: 0.05 } },
  };

  const _itemFila = {
    oculto: { opacity: 0, y: 14 },
    visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 260, damping: 18 } },
  };

  return (
    <section className="servicios" id="servicios">
      <AnimarAlScroll>
      <div className="contenedor">
        <button
          className={"precios-trigger " + (preciosAbierto ? "abierto" : "")}
          onClick={() => setPreciosAbierto(!preciosAbierto)}
          aria-expanded={preciosAbierto}
        >
          <div className="precios-trigger-texto">
            <h3>Precios</h3>
            <p>Mirá todos nuestros servicios y sus valores.</p>
          </div>
          <span className="precios-trigger-accion">
            {preciosAbierto ? "Ocultar" : "Ver precios"}
          </span>
        </button>

        <AnimatePresence initial={false}>
          {preciosAbierto && (
            <motion.div
              className="precios-desplegable"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            >
              <div className="precios-desplegable-inner">

        <div className="servicios-tabs">
          {_categorias.map((cat) => (
            <button
              key={cat.id}
              className={"servicios-tab " + (categoriaActiva === cat.id ? "activo" : "")}
              onClick={() => setCategoriaActiva(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {_notasDestacadas[categoriaActiva] && (
          <p className="servicios-destacado">{_notasDestacadas[categoriaActiva]}</p>
        )}

        {cargando ? (
          <div className="servicios-lista" aria-hidden="true">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="servicio-fila">
                <div className="skeleton" style={{ width: "45%", height: "22px" }}></div>
                <div className="servicio-fila-opciones">
                  <div className="skeleton" style={{ width: "92px", height: "52px", borderRadius: "12px" }}></div>
                  <div className="skeleton" style={{ width: "92px", height: "52px", borderRadius: "12px" }}></div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <motion.div
            className="servicios-lista"
            key={categoriaActiva}
            variants={_contenedorFilas}
            initial="oculto"
            animate="visible"
          >
            {_serviciosAgrupados.map((grupo) => (
              <motion.div key={grupo.nombre} className="servicio-fila" variants={_itemFila}>
                <div className="servicio-fila-nombre">{grupo.nombre}</div>
                <div className="servicio-fila-opciones">
                  {grupo.variantes.map((variante) => (
                    <div key={variante.id} className="servicio-opcion">
                      {variante.detalle && (
                        <span className="servicio-opcion-detalle">{variante.detalle}</span>
                      )}
                      <span className="servicio-opcion-precio">
                        $<PrecioAnimado valor={variante.precio} />
                      </span>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}

        {_notas[categoriaActiva] && (
          <p className="servicios-nota">{_notas[categoriaActiva]}</p>
        )}

        <div className="servicios-cta">
          <button className="btn-principal btn-reservar-animado" onClick={onReservar}>
            Reservar turno
          </button>
        </div>

              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      </AnimarAlScroll>
    </section>
  );
}

export default Servicios;